import { TESTS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import testsTypes from '../../constants/testsTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'


//
const get_test_request = () => {
  return {
    type: testsTypes.get.request
  }
}

const get_test_success = (response) => {
  return {
    type: testsTypes.get.success,
    payload: response.data.test
  }
}

const get_pdf_success = () => {
  return {
    type: testsTypes.pdf.success
  }
}

const get_test_failure = (messages) => {
  return {
    type: testsTypes.get.failure,
    payload: messages
  }
}

const get_test = (test_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_test_request())

    // Request
    axios.get(
      formatRoute(TESTS_ROUTES.get, {id: test_id})
    ).then( response => {
      // success

      dispatch( get_test_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching test."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_test_failure(errors))
    })
  }
}


const get_test_by_position = (skip=0, filters={}, sort='', order='') => {
  return function (dispatch) {
    // Before Request
    dispatch(get_test_request())

    // Request
    axios.get(
      TESTS_ROUTES.get_test_by_position,
      {
        params: {
          sort: sort,
          order: order,
          filters: filters,
          skip: skip
        }
      }
    ).then( response => {
      // success
      dispatch( get_test_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching test."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_test_failure(errors))
    })
  }
}


const get_test_report = (test_id, variant="default") => {
  // default: Question list
  // level: Questions per level
  return function (dispatch) {
    // Before Request
    dispatch(get_test_request())

    // Request
    axios.get(
      `${formatRoute(TESTS_ROUTES.get, {id: test_id})}.pdf`,
      {
        params: {
          variant: variant
        },
        responseType: 'blob'
      }
    ).then( response => {
      // success
      const blob = URL.createObjectURL(response.data, "test_download_pdf_link")
      const fileLink = document.createElement('a')
      document.body.appendChild(fileLink);
      fileLink.id = "test_download_pdf_link"
      fileLink.style="display: none"
      fileLink.href = blob
      fileLink.download = variant === "certificate" ? `${test_id}_certificate.pdf` : variant === "level" ? `${test_id}_test_levels.pdf` : `${test_id}_test_report.pdf`
      fileLink.click();
      URL.revokeObjectURL(blob)
      const fileAnchor = document.getElementById('test_download_pdf_link')
      fileAnchor.parentNode.removeChild(fileAnchor)
      dispatch( get_pdf_success() )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = [error]
        // errors = ["Error fetching pdf file."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_test_failure(errors))
    })
  }
}

export {
  get_test,
  get_test_report,
  get_test_by_position
}



// WEBPACK FOOTER //
// ./src/js/actions/tests/get.js